import { useEffect } from 'react';
import { useParams } from 'react-router-dom';

import { useGetBroadcastClips } from '@/features/clips/api/get-broadcast-clips';
import { WHOLE_CUT_LIST_FILTERS } from '@/features/clips/api/infinite-clips-page';
import { TClip } from '@/features/clips/types';
import { TSegment } from '@/features/segments/types';

import { ESegmentToolkit } from '../components/BroadcastScheduleProgramBody/components/BroadcastScheduleProgramBodySegmentToolkit/types';
import { useBroadcastScheduleProgram } from '../context/BroadcastScheduleProgramContext';

import { useGlobalViewPresencePreview } from './useGlobalViewPresencePreview';

type TUseGlobalViewBootstrapProps = {
  allSegments: TSegment[];
};

// RISK: must stay one stable array. `handlePresenceClick` depends on the clips, and an effect
// stores it in the context, so a fresh `[]` per render while they load re-renders in a loop.
const NO_CLIPS: TClip[] = [];

function useGlobalViewBootstrap({ allSegments }: TUseGlobalViewBootstrapProps) {
  const { id = '' } = useParams();
  const { setIsGlobalView, setGlobalViewSegments, setGlobalViewOnPreview, handleTooltikClick } =
    useBroadcastScheduleProgram();

  const { data: clipsData } = useGetBroadcastClips({
    id,
    filters: WHOLE_CUT_LIST_FILTERS,
  });
  const broadcastClips = clipsData?.data ?? NO_CLIPS;

  const { handlePresenceClick } = useGlobalViewPresencePreview({ broadcastClips });

  useEffect(() => {
    setIsGlobalView(true);
    handleTooltikClick(ESegmentToolkit.LOGOTIPO);
    return () => {
      setIsGlobalView(false);
      setGlobalViewSegments([]);
      setGlobalViewOnPreview(null);
    };
  }, []);

  useEffect(() => {
    setGlobalViewOnPreview(handlePresenceClick);
  }, [handlePresenceClick]);

  useEffect(() => {
    setGlobalViewSegments(allSegments);
  }, [allSegments]);
}

export { useGlobalViewBootstrap };
